<template>
  <v-container>
    <v-card outlined>
      <v-card-title>
        Tabella Prenotazioni/Hotel
        <v-dialog v-model="dialog">
          <template v-slot:activator="{ on }">
            <v-btn
              v-if="profile.is_staff"
              depressed
              small
              color="primary"
              class="ml-4"
              v-on="on"
            >
              Aggiungi
              <v-icon right>fa-plus</v-icon>
            </v-btn>
          </template>

          <v-card>
            <v-card-title>
              <template v-if="editedId > -1" class="headline">
                Modifica
              </template>
              <template v-else>Aggiungi</template>
              prenotazione
            </v-card-title>

            <v-divider></v-divider>

            <v-card-text class="pb-0 pt-4">
              <span v-if="get(error, 'non_field_errors')" class="red--text">
                {{ error.non_field_errors.join(" ") }}
              </span>
              <booking-form v-bind="{ editedItem, error, modelFk }" />
            </v-card-text>

            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="blue darken-1" text @click="closeDialog">
                Cancel
              </v-btn>
              <v-btn color="blue darken-1" text @click="save">Save</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-card-title>
      <v-card-text>
        <div style="margin-bottom: 20px;">
          <label for="hotelFilter">Seleziona Hotel:</label>
          <select
            id="hotelFilter"
            v-model="selectedHotelId"
            class="styled-select"
          >
            <option
              v-for="hotel in showHotels"
              :key="hotel.id"
              :value="hotel.id"
            >
              {{ hotel.hotel__name }}
            </option>
          </select>
        </div>
        <div v-if="filteredHotel">
          <h3 style="margin-bottom: 20px;">{{ filteredHotel.hotel__name }}</h3>
          <table>
            <thead>
              <tr>
                <th>Stanze/Date</th>
                <th
                  v-for="day in filteredHotel.daily_availabilities"
                  :key="day"
                >
                  {{ formatDate(day) }}
                </th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="room in filteredHotel.hotel__rooms" :key="room.id">
                <td>
                  <strong>{{ room.room__name }}</strong>
                </td>
                <td
                  v-for="day in filteredHotel.daily_availabilities"
                  :key="day"
                  :class="[
                    getBookingClass(getAvailability(room, day).booking),
                    getRoomAvailabilityClass(
                      getAvailability(room, day).isAvailable
                    ),
                  ]"
                  @click="editBooking(getAvailability(room, day).booking)"
                >
                  {{
                    getAvailability(room, day).booking
                      ? `Ospiti: ${
                          getAvailability(room, day).booking.booking__people
                        }`
                      : "No Booking"
                  }}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </v-card-text>
    </v-card>
  </v-container>
</template>

<script>
import BookingForm from "@/components/BookingForm"
import model from "../Bookings/model"
import { cloneDeep } from "lodash"

export default {
  name: "HotelsTableEndpoint",
  components: {
    BookingForm,
  },
  data() {
    return {
      showHotels: [],
      selectedHotelId: null,
      dialog: false,
      editedId: -1,
      editedItem: this.defaultItem(),
      error: {},
      model,
    }
  },
  computed: {
    showFk() {
      return this.$route.params.id
    },
    modelFk() {
      return { show: this.$route.params.id }
    },
    filteredHotel() {
      return this.showHotels.find((hotel) => hotel.id === this.selectedHotelId)
    },
  },
  created() {
    this.fetchShowHotels()
  },
  methods: {
    defaultItem: () => ({
      room: null,
      people: [],
      start_date: "",
      end_date: "",
      cost: 1,
      kind: 1,
      notes: "",
    }),
    async fetchShowHotels() {
        const response = await this.$axios.get("/api/hotels-table/", {
          params: { show_id: this.showFk },
        })
        this.showHotels = response.data.show_hotels
        if (this.showHotels.length > 0 && !this.selectedHotelId) {
          this.selectedHotelId = this.showHotels[0].id
        }
    },
    getAvailability(room, day) {
      if (!room.room__bookings || !Array.isArray(room.room__bookings)) {
        return { booking: null, isAvailable: false }
      }
      const dayDate = new Date(day).toISOString().split("T")[0]
      const booking = room.room__bookings.find((booking) => {
        if (!booking.start_date || !booking.end_date) {
          return false
        }
        const startDate = new Date(booking.start_date)
          .toISOString()
          .split("T")[0]
        const endDate = new Date(booking.end_date).toISOString().split("T")[0]
        return dayDate >= startDate && dayDate <= endDate
      })
      const isAvailable =
        room.daily_availabilities &&
        Array.isArray(room.daily_availabilities) &&
        room.daily_availabilities.some((availability) => {
          if (!availability.start_date || !availability.end_date) {
            return false
          }
          const startDate = new Date(availability.start_date)
            .toISOString()
            .split("T")[0]
          const endDate = new Date(availability.end_date)
            .toISOString()
            .split("T")[0]
          return dayDate >= startDate && dayDate <= endDate
        })
      return { booking, isAvailable }
    },
    getBookingClass(booking) {
      if (!booking) {
        return ""
      }
      switch (booking.status) {
        case 1:
          return "status-1"
        case 2:
          return "status-2"
        case 3:
          return "status-3"
        default:
          return ""
      }
    },
    getRoomAvailabilityClass(isAvailable) {
      return isAvailable ? "available" : "not-available"
    },
    formatDate(date) {
      const d = new Date(date)
      const day = String(d.getDate()).padStart(2, "0")
      const month = String(d.getMonth() + 1).padStart(2, "0")
      const year = d.getFullYear()
      return `${day}/${month}/${year}`
    },
    editBooking(booking) {
      if (!booking) {
        return
      }
      this.editedId = booking.id
      this.editedItem = cloneDeep(booking)
      this.dialog = true
    },
    async save() {
      let request
      if (this.editedId > -1) {
        // edit request
        request = this.$store.dispatch(`update${this.model.modelName}`, {
          params: { id: this.editedId },
          data: this.editedItem,
        })
      } else {
        // create request
        request = this.$store.dispatch(`create${this.model.modelName}`, {
          data: Object.assign({}, this.editedItem, this.modelFk),
        })
      }
      try {
        await request
        this.$store.commit("core/setSnack", {
          level: "success",
          msg: "Salvato",
        })
        this.fetchShowHotels()
        this.closeDialog()
      } catch (error) {
        this.error = error.response.data
      }
    },
    closeDialog() {
      this.dialog = false
      this.$nextTick(() => {
        this.error = {}
        this.editedItem = Object.assign({}, this.defaultItem())
        this.editedId = -1
      })
    },
  },
}
</script>

<style scoped>
/* Add your styles here */
table {
  width: 100%;
  border-collapse: collapse;
}

th,
td {
  border: 1px solid #ddd;
  padding: 8px;
}

th {
  background-color: #f2f2f2;
  text-align: left;
}

.styled-select {
  padding: 0 10px;
  margin-left: 10px;
  border: 2px solid #ccc;
  border-radius: 4px;
  background-color: #f8f9fa;
  color: #333;
  outline: none;
  transition: border-color 0.3s;
}

.styled-select:focus {
  border-color: #0056b3;
}

.status-1 {
  background-color: #f0f0f0; /* Very light grey */
}

.status-2 {
  background-color: #ffff99; /* Yellow */
}

.status-3 {
  background-color: #ccffcc; /* Green */
}

.available {
  border: 3px solid green; /* Heavier green border */
}

.not-available {
  border: 3px solid red; /* Heavier red border */
}
</style>
